module.exports = __webpack_public_path__ + "static/media/image3.9ca930f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AiDesign/image3.jpg
// module id = 1109
// module chunks = 0